<template>
	<Skeleton :paragraph="{ rows: 7 }" :title="false" :loading="isLoading">
		<VerticalLayout>
			<TablePaginationToolbar
				ref="paginationToolbarRef"
				v-model:items="items"
				:pageSize="10"
			/>
			<div class="scrollable-x">
				<Table
					:columns="columns"
					:data-source="paginatedItems"
					:pagination="false"
					size="small"
					row-key="run_at"
				>
					<template #bodyCell="{ column, record }">
						<template v-if="column.dataIndex === 'run_at'">
							<DateTimeDisplay :date="record.run_at" hideUtc />
						</template>
					</template>
				</Table>
			</div>
		</VerticalLayout>
	</Skeleton>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { Skeleton, Table } from 'ant-design-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';

import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import TablePaginationToolbar from '@/components/common/TablePaginationToolbar.vue';
import VerticalLayout from '@/components/common/VerticalLayout';

export default {
	components: {
		Skeleton, Table, DateTimeDisplay, TablePaginationToolbar, VerticalLayout,
	},
	setup() {
		const isLoading = ref(false);
		const items = ref([]);
		const columns = Consts.versionHistoryTableColumnsComp;
		const paginationToolbarRef = ref(null);
		const paginatedItems = computed(() => (
			paginationToolbarRef.value != null ? paginationToolbarRef.value.paginatedItems : []
		));

		const fetchData = () => {
			isLoading.value = true;
			Api.versionHistoryGet(response => {
				if (response.status === 'ok') {
					items.value = response.items || [];
				}
				isLoading.value = false;
			});
		};

		onMounted(fetchData);

		return {
			isLoading,
			items,
			columns,
			paginationToolbarRef,
			paginatedItems,
		};
	},
}
</script>
